import i18next from 'i18next';
import { format, isValid, parseISO } from 'date-fns';
import { mapUserLocaleToShorthand } from 'i18n/mapUserLocaleToShorthand';

export default (
  inputDate: string | Date,
  formattingString?: string,
): string | null => {
  const date = typeof inputDate === 'string' ? parseISO(inputDate) : inputDate;

  if (!isValid(date)) {
    return null;
  }

  let localeDefaultFormattingString;
  switch (i18next.language) {
    case 'en-GB':
      localeDefaultFormattingString = 'h:mm aaa, PPPP';
      break;

    default:
      localeDefaultFormattingString = 'PPPp';
  }

  return format(date, formattingString || localeDefaultFormattingString, {
    locale: mapUserLocaleToShorthand(),
  });
};
